export const handleUserKeyPress = (event, player,live) => {
    const keyCode=event.keyCode;
    const shiftKey=event.shiftKey;
    const ctrlKey=event.ctrlKey;
    if (
        !(shiftKey || ctrlKey )
    ) {
        if (keyCode === 27) {
            if (player.isFullscreen()){
                player.exitFullscreen();
            }
        }
        if (keyCode === 32 || keyCode === 75 || keyCode === 80 ) {
            player.paused() ? player.play() : player.pause();
        }
        if (keyCode == 77) {
            player.muted(!player.muted())
        }
        if ((keyCode === 76 || keyCode===39) && (player.options_.isDvr || !live) ) {
            if (event.getModifierState('CapsLock')){
                player.currentTime(player.currentTime() + 30)

            }else{
                player.currentTime(player.currentTime() + 10)

            }
        }
        if ((keyCode === 74 || keyCode===37) && (player.options_.isDvr || !live)) {
            if (event.getModifierState('CapsLock')){
                player.currentTime(player.currentTime() - 30)

            }else{
                player.currentTime(player.currentTime() - 10)

            }
        }         
        if (keyCode == 107 || keyCode == 38 && player.volume() < 1) {
            player.volume(player.volume() + 0.2)
        }
        if (keyCode == 109 || keyCode == 40 && player.volume() > 0) {
            player.volume(player.volume() - 0.2)
        }
        if (keyCode == 70) {
            player.isFullscreen()
                ? player.exitFullscreen() : player.requestFullscreen()
        }
    }else{
        if (keyCode == 13) {
            player.isFullscreen()
                ? player.exitFullscreen() : player.requestFullscreen()
        }
    }
}